// 共有カード（OGP）や canonical に使う公開 URL を正規化する。
// 絶対 URL であることが必須なので、壊れた値は握りつぶさずビルド時に落とす。
const normalizeSiteUrl = (value: string): string => {
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    throw new Error(`NEXT_PUBLIC_SITE_URL は絶対 URL である必要があります: ${value}`);
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    throw new Error(`NEXT_PUBLIC_SITE_URL は http(s) である必要があります: ${value}`);
  }
  return url.origin;
};

// Application Configuration
export const appConfig = {
  // Application Branding
  name: process.env.NEXT_PUBLIC_APP_NAME || 'ログミー',
  description: process.env.NEXT_PUBLIC_APP_DESCRIPTION || '営業・給与・バック管理システム',
  // ロゴのワードマーク。name（ページタイトル等に使う表示名）とは別物
  wordmark: process.env.NEXT_PUBLIC_APP_WORDMARK || 'LogMe',

  // Application Meta
  url: process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000',
  // 共有カード（OGP）や canonical に使う公開 URL。
  // ⚠️ 本番単一ドメイン前提。本番ビルドに NEXT_PUBLIC_APP_URL が渡されておらず
  //    appConfig.url が localhost にフォールバックしてしまうため、別途これを用意している。
  //    dev 等ドメインが変わる環境を共有対象にするなら NEXT_PUBLIC_SITE_URL を必ず設定すること。
  siteUrl: normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL || 'https://logmeapp.com'),
  version: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
  
  // Backend API
  backendUrl: process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:8080',
} as const;

// Icon Size Presets
export const iconSizes = {
  '4xs': 3,
  '3xs': 6,
  '2xs': 8,
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  '2xl': 40,
  '3xl': 48,
} as const;

// Font Size Presets
export const fontSizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
} as const;

// Page Title Helper
export const getPageTitle = (pageName: string) => `${pageName} - ${appConfig.name}`;

// Meta Description Helper
export const getMetaDescription = (description: string) => `${description} - ${appConfig.name}`;

// Global Icon Size Configuration
export const globalIconConfig = {
  // デフォルトサイズ（環境変数で変更可能）
  defaultSize: '4xs',
  defaultFontSize: 'xs',
  
  // 各コンポーネントのサイズ設定
  sizes: {
    header: '4xs',
    auth: '3xs',
    dashboard: '4xs',
  } as const,
} as const; 